<template>
  <span>
    <i class="fas fa-spinner fa-pulse" v-if="this.$store.getters['limits/isLoadingTypesForSelect']"></i>&nbsp;{{ this.format }}
  </span>
</template>

<script>
export default {
  props: [
    'value',
  ],
  computed: {
    format() {
      if (this.$store.getters['isShowDebugTools']) {
        return this.value;
      }

      if (this.$store.getters['limits/typesForSelect']) {
        const type = this.$store.getters['limits/typesForSelect'].find(gameType => gameType.value === this.value);

        return type ? type.label : '';
      }

      return this.value;
    },
  },
  mounted() {
    if (!this.$store.getters['limits/isLoadedTypesForSelect']) {
      this.$store.dispatch('limits/loadTypesForSelect');
    }
  },
}
</script>
